import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    tipoBox: {
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.primary.main,
        padding: '2px 5px',
    },
    titleDialog: {
        alignItems: 'initial'
    },
    weight: {
        fontWeight: 700,
        lineHeight: 1.3
    },
    btnVotado: {
        '& svg': {
            fill: theme.palette.common.white
        }
    },
    disabled: {
        cursor: 'not-allowed',
        borderColor: theme.palette.error.main,
        backgroundColor: "#f443360a",
        color: theme.palette.text.primary,
        '& svg': {
            fill: theme.palette.error.main
        },
        '&:hover': {
            borderColor: theme.palette.error.dark,
        }
    },
    content: {
        gap: 8,
        display: 'flex',
        flexDirection: 'column',
    }
}))